<template>
  <div
    ref="formWrapper"
    class="input-component chat-textarea">
    <v-container>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation>
        <v-layout>
          <v-text-field
            v-model="message"
            textarea
            required
            :counter="500"
            class="textarea pt-0"
            hint="Digite a mensagem que deseja enviar"
            persistent-hint
            :rules="maxLength500"
            @keypress.enter="save" />
          <v-btn
            v-if="isMobile"
            :disabled="!valid"
            color="accent"
            class="btn-mobile-save"
            data-cy="btnSave"
            icon
            @click.native="save">
            <v-icon small>
              mdi-send
            </v-icon>
          </v-btn>
          <v-btn
            v-else
            :disabled="!valid"
            color="primary"
            data-cy="btnSave"
            @click.native="save">
            Enviar
          </v-btn>
        </v-layout>
      </v-form>
    </v-container>
  </div>
</template>

<script>
  import validate from '@/mixins/validate'

  export default {
    mixins: [validate],
    data () {
      return {
        message: '',
        valid: true
      }
    },
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.smAndDown
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.anime({
          targets: this.$refs.formWrapper,
          translateX: 0,
          opacity: [
            { value: 0, duration: 100 },
            { value: 1, duration: 350 }
          ]
        })

        document.querySelector('.textarea textarea') !== null && this.focus()
      })
    },
    methods: {
      save (ev) {
        ev.preventDefault()
        if (this.$refs.form.validate()) {
          let option = {
            slug: 'AnwerGuest',
            value: this.message,
            topic: this.$route.params.caseId
          }
          this.$emit('send', option)
          this.$refs.form.reset()
        }
      },
      focus () {
        document.querySelector('.textarea textarea').focus()
      }
    }
  }
</script>

<style lang="sass">
  @import '../../assets/style/variables'

  .chat-textarea
    top: -35px
    max-width: 100%
    margin: 0 auto

    .v-input-group
      padding-top: 0

    .v-input-group--text-field.v-input-group--textarea

      .v-input-group__input
        padding: 10px
        border: 2px solid $bgColor

        textarea
          height: 45px

      .v-input-group__details
        padding-top: 0

    .textarea
      margin-right: 10px

    .btn-mobile-save,
    .btn-mobile-prev
      margin-top: 10px
</style>
